module.exports = __webpack_public_path__ + "img/hero-man.49d0a595.svg";